import { generateActions } from "../generateActions";
import { objHocSinhViewShortDefine } from "../../action-types/thuc-don/IHocSinhViewShortActionTypes";

export const hocSinhViewShortActions = {
    ...generateActions(objHocSinhViewShortDefine, "HOC_SINH_VIEW_SHORT"),
};
